<template>
    <div>
        <div v-if="privateData.values !== null" class="evidence-wrapper row">
            <div :class="{ 'col-6': privateData.values.items.length > 1, 'col-12': privateData.values.items.length == 1   }" v-for="item in privateData.values.items">
                <div v-if="item.image"><img :src="item.image" alt="evidence image" /></div>
                <div v-if="item.embed" class="embed" v-html="item.embed"></div>
                <div v-if="item.url !== null" class="mt-3 mb-4"><a :href="item.url" target="_blank">{{ item.link_title[store.lang] }}</a></div>
                <div v-if="item.url === null" class="mt-3 mb-4"><a @click.stop.prevent="">{{ item.link_title[store.lang] }}</a></div>
            </div>
            <div class="col-12 excerpt" v-html="privateData.values.text[store.lang]"></div>
        </div>
    </div>
</template>

<script>
import { store } from '../store.js'

export default {
    name: 'evidence',
    data() {
        return {
            privateData: {
                values: null
            },
			store
        };
    },
    created() {
        this.$watch('$evidence.value', (newVal) => {
            this.privateData.values = JSON.parse(newVal);
        }, { immediate: true });

        this.privateData.values = JSON.parse(this.$evidence.value);
    }
}
</script>

<style lang="scss" scoped>
    .evidence-wrapper {
        max-height: 50vh;
        transition: 0.3s;

        img {
            width: 100%;
            border-radius: 10px;
        }

        a {
            color: #fff;
            font-size: 18px;
            text-decoration: underline;
            @media(max-width: 400px) {
              font-size: 14px;
            }
            &:hover {
                text-decoration: none;
            }
        }
        .excerpt {
            font-size: 16px;
            color: #ccc;
            font-family: "Zilla Slab", "Courier New", Courier, monospace;
            @media(max-width: 400px) {
              font-size: 14px;
            }

        }
    }
</style>
